import Reveal from "./Reveal";

export const LugoSection = () => (
    <section className="py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
            <div className="lg:col-span-6 order-2 lg:order-1">
                <Reveal>
                    <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-terracotta">
                        Emilia-Romagna
                    </p>
                    <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-ink">
                        Da Lugo, il cuore
                        <br />
                        della <em className="italic text-terracotta">Bassa Romagna.</em>
                    </h2>
                    <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-mutedwarm">
                        La nostra casa è Lugo, in provincia di Ravenna: da qui
                        partiamo ogni giorno per portare il supporto quotidiano
                        in tutta l'Emilia-Romagna. Conosciamo i vicoli, le
                        piazze e i volti del nostro territorio — ed è proprio
                        lì che siamo più utili.
                    </p>
                </Reveal>
            </div>

            <div className="lg:col-span-6 order-1 lg:order-2">
                <Reveal y={40} className="relative max-w-[560px] mx-auto">
                    <div className="rounded-[28px] overflow-hidden group relative">
                        <img
                            src="/lugo.jpg"
                            alt="Una piazza di Lugo, in provincia di Ravenna"
                            loading="lazy"
                            className="h-[320px] sm:h-[440px] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                        />
                        <div
                            aria-hidden="true"
                            className="absolute inset-0 bg-ink/10 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                        />
                    </div>
                    <div className="absolute -bottom-6 left-5 sm:left-8 rounded-2xl bg-terracotta text-cream px-6 py-4 shadow-xl shadow-terracotta/25">
                        <p className="font-serif text-lg italic leading-snug">
                            Piazza di Lugo
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default LugoSection;
